import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const WarningSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default WarningSVG;
